"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAgentInformationService = void 0;
const utils_1 = require("@hc-frontend/utils");
const __1 = require("..");
/**
 * Fetch the information of the agent from HC backend
 *
 * @public
 *
 * @param agentId The agent id
 *
 * @returns The agent information if found, otherwise null
 *
 * @remarks
 * The API sometimes returns code `204` but without data, in this case null is returned
 *
 * @example
 * ```ts
 * const agentInfo = await fetchAgentInformationService('1');
 * ```
 */
async function fetchAgentInformationService(agentId) {
    const agentUrl = `${(0, __1.getPivotBackendURI)()}/agent/${agentId}`;
    const { parsedBody } = await (0, utils_1.fetchJSON)(agentUrl);
    return (parsedBody === null || parsedBody === void 0 ? void 0 : parsedBody.data) ? parsedBody : null;
}
exports.fetchAgentInformationService = fetchAgentInformationService;
//# sourceMappingURL=fetch-agent-information-service.js.map